/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Datetimeisaspect5Inputs */

const de__class_datetimeisaspect5 = /** @type {(inputs: _Class_Datetimeisaspect5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist`)
};

/**

* @param {_Class_Datetimeisaspect5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_datetimeisaspect5 = /** @type {((inputs?: _Class_Datetimeisaspect5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Datetimeisaspect5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_datetimeisaspect5(inputs)
});
export { _class_datetimeisaspect5 as "_class_DateTimeISAspect" }